function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "filters");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "filters",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Adjust-Type-2",
  transform: "translate(5.000000, 3.000000)",
  stroke: "currentColor",
  strokeWidth: 4
}, React.createElement("g", {
  id: "Group-4"
}, React.createElement("line", {
  x1: 0,
  y1: 5.31195335,
  x2: 4.84848485,
  y2: 5.31195335,
  id: "Path-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 18,
  y1: 5.31195335,
  x2: 39.8181818,
  y2: 5.31195335,
  id: "Path-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 11,
  cy: 4.85714286,
  rx: 5,
  ry: 4.85714286
})), React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 34.285714)"
}, React.createElement("line", {
  x1: 0,
  y1: 5.31195335,
  x2: 4.84848485,
  y2: 5.31195335,
  id: "Path-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 18,
  y1: 5.31195335,
  x2: 39.8181818,
  y2: 5.31195335,
  id: "Path-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 11,
  cy: 4.85714286,
  rx: 5,
  ry: 4.85714286
})), React.createElement("g", {
  id: "Group-4",
  transform: "translate(20.000000, 22.632653) scale(-1, 1) translate(-20.000000, -22.632653) translate(0.000000, 17.632653)"
}, React.createElement("line", {
  x1: 0,
  y1: 5.31195335,
  x2: 4.84848485,
  y2: 5.31195335,
  id: "Path-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 18,
  y1: 5.31195335,
  x2: 39.8181818,
  y2: 5.31195335,
  id: "Path-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 11,
  cy: 4.85714286,
  rx: 5,
  ry: 4.85714286
}))));

var SvgFilters = function SvgFilters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilters, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filters.fefdb27e.svg";
export { ForwardRef as ReactComponent };